import React, { useRef, useState } from "react";
import { Row, Col, Card, Typography, message } from "antd";
import CreateBankQRForm from "./CreateBankQRForm";
import BankQRResult from "./BankQRResult";
import { getVietQRBase64 } from "helper/vietqr";

const vietQRBase =
  "https://img.vietqr.io/image/{bank}-{account}-{template}.png?amount={amount}&addInfo={addInfo}";

const keyLastQR = "last_qr";
const keyAmountSample = "amount_sample";

function buildVietQRUrl({ bank, account, amount, addInfo }) {
  let url = vietQRBase
    .replace("{bank}", bank)
    .replace("{account}", account)
    .replace("{template}", "compact");

  url = url.replace("{amount}", amount || "");
  url = url.replace("{addInfo}", encodeURIComponent(addInfo || ""));
  return url;
}

const listAmountSampleDefault = [40000, 250000, 290000, 330000, 350000];

const CreateBankQR = () => {
  const [qrUrl, setQrUrl] = useState(null);
  const qrRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const saveLastQR = (values) => {
    localStorage.setItem(keyLastQR, JSON.stringify(values));
  };

  const addAmountSample = (amount) => {
    let list = [];
    const listAmountSample = localStorage.getItem(keyAmountSample);
    if (listAmountSample) {
      list = JSON.parse(listAmountSample);
      if (
        list.includes(amount) ||
        listAmountSampleDefault.includes(Number(amount))
      ) {
        return;
      }
      list.push(amount);
      localStorage.setItem(keyAmountSample, JSON.stringify(list));
    }
    if (
      !listAmountSample &&
      !listAmountSampleDefault.includes(Number(amount))
    ) {
      list.push(amount);
      localStorage.setItem(keyAmountSample, JSON.stringify(list));
    }
  };

  const onFinish = (values) => {
    if (!values.bank || !values.account) {
      message.error("Vui lòng chọn ngân hàng và nhập số tài khoản");
      return;
    }

    setLoading(true);

    const url = buildVietQRUrl({
      bank: values.bank,
      account: values.account,
      amount: values.amount,
      addInfo: values.addInfo,
    });
    getVietQRBase64(url).then((base64) => {
      setQrUrl(base64);
      setLoading(false);
    });
    saveLastQR({
      bank: values.bank,
      account: values.account,
      accountName: values.accountName,
    });
    addAmountSample(values.amount);
  };

  const handlePrint = () => {
    if (!qrRef.current) return;
    const content = qrRef.current.innerHTML;
    const printWindow = window.open("", "", "width=400,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>In mã QR</title>
          <style>
            body { display: flex; align-items: center; justify-content: center; height: 100vh; margin: 0; }
            img { max-width: 100%; }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const handleDownload = async () => {
    if (!qrUrl) return;
    try {
      const response = await fetch(qrUrl, { mode: "cors" });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `qr-code_${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Không thể tải ảnh. Có thể server không cho phép tải về.");
    }
  };

  return (
    <div style={{ width: "100%", padding: 0 }}>
      <Row gutter={32}>
        <Col style={{ borderRight: "1px solid #ccc" }} xs={24} md={12}>
          <Card
            title={
              <Typography.Title
                level={4}
                style={{ margin: 0, textAlign: "center" }}
              >
                Thông tin tạo mã
              </Typography.Title>
            }
            bordered={false}
            style={{ minHeight: 580 }}
            bodyStyle={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
            }}
          >
            <CreateBankQRForm onFinish={onFinish} />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <BankQRResult
            qrUrl={qrUrl}
            qrRef={qrRef}
            onPrint={handlePrint}
            onDownload={handleDownload}
            loading={loading}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CreateBankQR;
